import styled, { css } from 'styled-components'

type Props = {
  startAnimation?: boolean
  seedPosition?: number
  bottomImagesPosition?: number
}

const ComponentStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  min-height: 100vh;

  .global-page-wrapper {
    background-color: ${({ theme }) => theme.colors.brown2};
    padding: 60px 0;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
      padding: 140px 0 200px 0;
    }

    .steps {
      position: relative;
      z-index: 2;
      margin-bottom: 700px;

      @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
        margin-bottom: 150px;
      }

      .seed-prev-img {
        position: relative;
        text-align: center;
        top: ${({ startAnimation, seedPosition }) => (startAnimation ? `${(seedPosition || 0) - 10}px` : '-11px')};
        left: 50%;
        transform: translateX(-50%);

        ${({ startAnimation }) =>
          startAnimation &&
          css`
            animation-name: slidein;
            animation-duration: 3s;
            animation-fill-mode: forwards;
          `}
      }
    }

    .bottom-images {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }

  @keyframes slidein {
    from {
      top: -11px;
    }

    to {
      top: ${({ seedPosition }) => `${(seedPosition || 0) + 40}px`};
    }
  }
`

export default ComponentStyled
